import * as actions from "../global/actionTypes";

export const updateFilterState = filter => ({
  type: actions.UPDATE_FILTER_STATE,
  filter,
});



// WEBPACK FOOTER //
// ./src/actions/filter.js